import Immutable from 'immutable'

export default function flatMap(_nodes, _transform) {
  let index = 0
  const recursion = function (nodes, transform, level) {
    return nodes.reduce((result, node) => {
      const currentItem = transform(node, index++)
      const subItems = recursion(node.get('children'), transform, level + 1)
      return result.push(currentItem).concat(subItems)
    }, Immutable.fromJS([]))
  }
  return recursion(_nodes, _transform, 0)
}
